module.exports = __webpack_public_path__ + "static/media/59f78abf-2817-4e61-9e1e-ee00fab81c0e.3a98cd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/59f78abf-2817-4e61-9e1e-ee00fab81c0e.png
// module id = 1466
// module chunks = 0